import { useAction } from 'core/store/store';
import { useEffect } from 'react';
import { useHistory } from 'react-router';
import { RoutePath } from 'RoutePath';
import { makeAuthSetFakeStatusAction } from 'state/auth/actions';
import { makeOnboardingInitFakeStoreAction } from 'state/onboarding/actions';

export const FakeStoreRegistration = () => {
    const action = useAction();
    const history = useHistory();
    useEffect(() => {
        action(makeAuthSetFakeStatusAction, true);
        action(makeOnboardingInitFakeStoreAction);
        history.push(RoutePath.REGISTRATION);
    }, []);
    return <></>;
};
